export default __webpack_public_path__ + "e6a0f3afd537f11151d85c02abc66bc4.png";